import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import Select from '@bufferapp/ui/Select'
import { ChevronDown, ChevronUp } from '@bufferapp/ui/Icon'

import { ChannelAvatar } from '~/modules/channel/components'
import { shortenText } from '~/shared/utils/strings'

import {
  Wrapper,
  ButtonWrapper,
  ChannelWrapper,
  AvatarWrapper,
  ChannelInfo,
  ChannelName,
  ChannelStatus,
} from './styles'

const MAX_NAME_SIZE = 15

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'channels' implicitly has an 'any'... Remove this comment to see the full error message
const ChannelSelector = ({ channels, selected, onSelect }) => {
  const [opened, setOpened] = useState(false)

  useEffect(() => {
    if (opened) {
      document.addEventListener('click', onClose, true)
    } else {
      document.removeEventListener('click', onClose, true)
    }
  }, [opened])

  const onClose = useCallback(
    (event: any) => {
      setOpened(false)
    },
    [setOpened],
  )

  const onClick = useCallback(
    (event: any) => {
      setOpened(true)
    },
    [setOpened],
  )

  if (!channels || !selected) {
    return null
  }

  // @ts-expect-error TS(7006) FIXME: Parameter 'channel' implicitly has an 'any' type.
  const renderButton = (channel, onButtonClick) => (
    <ButtonWrapper
      onClick={() => {
        // @ts-expect-error TS(2554) FIXME: Expected 1 arguments, but got 0.
        onClick()
        onButtonClick()
      }}
    >
      {renderChannel(channel)}
      {opened ? <ChevronUp /> : <ChevronDown />}
    </ButtonWrapper>
  )

  // @ts-expect-error TS(7031) FIXME: Binding element 'id' implicitly has an 'any' type.
  const renderChannel = ({ id, name, avatar, service, isDisconnected }) => (
    <ChannelWrapper id={id}>
      <AvatarWrapper>
        <ChannelAvatar image={avatar} alt="" service={service} />
      </AvatarWrapper>
      <ChannelInfo>
        <ChannelName>{shortenText(name, MAX_NAME_SIZE)}</ChannelName>
        {isDisconnected && <ChannelStatus>Expired</ChannelStatus>}
      </ChannelInfo>
    </ChannelWrapper>
  )

  // NOTE: Passing the component as the icon was the only way I've found
  // to easily pass a custom component to <Select>.
  // @ts-expect-error TS(7006) FIXME: Parameter 'channel' implicitly has an 'any' type.
  const items = channels.map((channel) => ({
    id: channel.serviceId,
    icon: renderChannel(channel),
    onItemClick: () => onSelect(channel.id),
  }))

  return (
    <Wrapper id="channel-selector-wrapper">
      <Select
        // @ts-expect-error TS(2769) FIXME: No overload matches this call.
        onSelectClick={(selectedItem) => selectedItem.onItemClick()}
        // @ts-expect-error TS(7006) FIXME: Parameter 'onButtonClick' implicitly has an 'any' ... Remove this comment to see the full error message
        customButton={(onButtonClick) => renderButton(selected, onButtonClick)}
        items={items}
        hideSearch
        capitalizeItemLabel={false}
        fullWidth
        onClose={onClose}
      />
    </Wrapper>
  )
}

ChannelSelector.propTypes = {
  channels: PropTypes.array,
  selected: PropTypes.object,
  onSelect: PropTypes.func,
}

ChannelSelector.defaultProps = {
  channels: [],
  selected: null,
  onSelect: () => {},
}

export default ChannelSelector
